<section class="embed-page">
  <h1>Microapp Template</h1>
  <p>Ruta base embebible: <code>/embed/example</code></p>
</section>
